import { MULTILANGUAGEGQLSCHEMA } from "./MultiLanguage";

export const BETTINGWEBSITEQANDAGQLSCHEMA = `
id
Question{
    ${MULTILANGUAGEGQLSCHEMA}
}
Type
`;
